import { render } from "./message-desk.vue?vue&type=template&id=9baab004&ts=true"
import script from "./message-desk.vue?vue&type=script&lang=ts"
export * from "./message-desk.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__